export const config = {
  title: "Fast Painting | Professional Painting Services in NY & Pennsylvania",
  meta: {
    description:
      "Fast Painting provides expert painting services in New York and Pennsylvania. Specializing in residential and commercial painting, remodeling, and carpentry with a commitment to quality and customer satisfaction.",
    keywords: [
      'Painting Services NY',
      'Painting Services PA',
      'Residential Painting',
      'Commercial Painting',
      'Carpentry Services',
      'Remodeling Services',
      'Fast Painting',
      'MyBizSolutions LLC',
      'BizSolutions LLC'
    ],
    author: "Fast Painting",
    canonicalUrl: 'https://fastpaintingnj.com/',
  },
  sections: {
    header: {
      businessName: "Fast Painting",
    },
    sectionB: {
      heroTitle: "Fast Painting",
      heroSubtitle: 'Reliable & Professional Painting Solutions',
      learnAboutText: 'Explore Services',
      phoneNumber: '8628880318',
      phoneLabel: '(862) 888-0318',
      heroBackgroundImage:
        'https://media.istockphoto.com/id/1672351176/photo/painter-rolling-paint-reaching-to-cover.jpg?s=612x612&w=0&k=20&c=bqpYDe0Ow09NWgfNLVibUVR_wccOCbfOmY5Md1jxJSw=',
      cardData: [
        {
          title: 'Fully Licensed & Insured',
          description:
            'Fast Painting is fully licensed and insured, ensuring your project is handled with professionalism and care.',
        },
        {
          title: 'Professional Staff',
          description:
            'Our team is dedicated to providing exceptional craftsmanship and customer service to meet your painting and remodeling needs.',
        },
        {
          title: 'Customer Satisfaction',
          description:
            'We work closely with you to ensure the final results exceed your expectations. Your satisfaction is our top priority.',
        },
      ],
      description:
        "At Fast Painting, we take pride in delivering high-quality painting and remodeling services. Our experienced team ensures every project is completed with precision, efficiency, and a keen eye for detail. From residential homes to commercial properties, we bring your vision to life with expert craftsmanship and superior materials. Customer satisfaction is at the core of our business, and we strive to exceed expectations on every project.",
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        "Fast Painting is committed to offering top-notch painting, carpentry, and remodeling services. Whether you're updating your home or business, we have the expertise to make your space shine.",
      cards: [
        {
          title: 'Cabinet Installation',
          description:
            'Custom cabinet installation to enhance your kitchen, bathroom, or workspace with precision and care.',
          imageSrc:
            'https://fastpaintingnj.com/wp-content/uploads/2025/01/Fast-Painting-gallery-7-400x284.jpg',
          imageAlt: 'Cabinet Installation Services',
        },
        {
          title: 'Carpentry',
          description:
            'Expert carpentry services to upgrade your interiors with stylish and durable woodwork.',
          imageSrc:
            'https://fastpaintingnj.com/wp-content/uploads/2025/01/Fast-Painting-gallery-24.jpg',
          imageAlt: 'Carpentry Services',
        },
        {
          title: 'Painting',
          description:
            'Professional interior and exterior painting to refresh and enhance your residential or commercial property.',
          imageSrc:
            'https://fastpaintingnj.com/wp-content/uploads/2025/01/Fast-Painting-gallery-40-400x284.jpg',
          imageAlt: 'Painting Services',
        },
      ],
      otherServicesTitle: 'Other Services',
      otherServicesList: [
        'General Remodeling',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://fastpaintingnj.com/wp-content/uploads/2025/01/Fast-Painting-gallery-9-400x284.jpg',
        alt: "Fast Painting",
      },
      aboutText: [
        "Fast Painting has over 15 years of experience in the painting and remodeling industry, serving New York and Pennsylvania with top-tier craftsmanship.",
        "We are committed to delivering outstanding results, ensuring each project is completed with precision, reliability, and customer satisfaction.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Fast Painting Logo",
      businessName: "Fast Painting",
      contact: {
        phone: '8628880318',
        phoneLabel: '(862) 888-0318',
        email: 'tlamintzijovanny@gmail.com',
        website: 'https://fastpaintingnj.com/',
        address: '35 8th St. Bldg. #7 Passaic, NJ 07055, US',
      },
      socialMedia: {
        googlePlus: null,
        linkedIn: null,
        facebook: "https://www.facebook.com/profile.php?id=61561010941715",
        twitter: null,
        tiktok: null,
        instagram: "https://www.instagram.com/jovatlamintzi/",
        youtube: null,
      },
    },
    sectionF: {
      address: '35 8th St. Bldg. #7, Passaic, NJ 07055, US',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3021.9999999999995!2d-74.128422!3d40.857876!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2f6c5f5f5f5f5%3A0x123456789abcdef!2s35%208th%20St%2C%20Passaic%2C%20NJ%2007055%2C%20USA!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus',
    },    
  },
};

export default config;